"use strict";

var _toConsumableArray = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var os = require("os");

var constants = require("./constants");

var accounts_1 = require("./resources/accounts");

var blocks_1 = require("./resources/blocks");

var dapps_1 = require("./resources/dapps");

var delegates_1 = require("./resources/delegates");

var node_1 = require("./resources/node");

var peers_1 = require("./resources/peers");

var signatures_1 = require("./resources/signatures");

var transactions_1 = require("./resources/transactions");

var voters_1 = require("./resources/voters");

var votes_1 = require("./resources/votes");

var defaultOptions = {
  bannedNodes: [],
  randomizeNodes: true
};
var commonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

var getClientHeaders = function getClientHeaders(clientOptions) {
  var _clientOptions$name = clientOptions.name,
      name = _clientOptions$name === void 0 ? '????' : _clientOptions$name,
      _clientOptions$versio = clientOptions.version,
      version = _clientOptions$versio === void 0 ? '????' : _clientOptions$versio,
      _clientOptions$engine = clientOptions.engine,
      engine = _clientOptions$engine === void 0 ? '????' : _clientOptions$engine;
  var liskElementsInformation = 'LiskElements/1.0 (+https://github.com/LiskHQ/lisk-elements)';
  var locale = process.env.LC_ALL || process.env.LC_MESSAGES || process.env.LANG || process.env.LANGUAGE;
  var systemInformation = "".concat(os.platform(), " ").concat(os.release(), "; ").concat(os.arch()).concat(locale ? "; ".concat(locale) : '');
  return {
    'User-Agent': "".concat(name, "/").concat(version, " (").concat(engine, ") ").concat(liskElementsInformation, " ").concat(systemInformation)
  };
};

var APIClient = /*#__PURE__*/function () {
  _createClass(APIClient, null, [{
    key: "createMainnetAPIClient",
    value: function createMainnetAPIClient(options) {
      return new APIClient(constants.MAINNET_NODES, Object.assign({
        nethash: constants.MAINNET_NETHASH
      }, options));
    }
  }, {
    key: "createTestnetAPIClient",
    value: function createTestnetAPIClient(options) {
      return new APIClient(constants.TESTNET_NODES, Object.assign({
        nethash: constants.TESTNET_NETHASH
      }, options));
    }
  }, {
    key: "constants",
    get: function get() {
      return constants;
    }
  }]);

  function APIClient(nodes) {
    var providedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, APIClient);

    this.initialize(nodes, providedOptions);
    this.accounts = new accounts_1.AccountsResource(this);
    this.blocks = new blocks_1.BlocksResource(this);
    this.dapps = new dapps_1.DappsResource(this);
    this.delegates = new delegates_1.DelegatesResource(this);
    this.node = new node_1.NodeResource(this);
    this.peers = new peers_1.PeersResource(this);
    this.signatures = new signatures_1.SignaturesResource(this);
    this.transactions = new transactions_1.TransactionsResource(this);
    this.voters = new voters_1.VotersResource(this);
    this.votes = new votes_1.VotesResource(this);
  }

  _createClass(APIClient, [{
    key: "banActiveNode",
    value: function banActiveNode() {
      return this.banNode(this.currentNode);
    }
  }, {
    key: "banActiveNodeAndSelect",
    value: function banActiveNodeAndSelect() {
      var banned = this.banActiveNode();

      if (banned) {
        this.currentNode = this.getNewNode();
      }

      return banned;
    }
  }, {
    key: "banNode",
    value: function banNode(node) {
      if (!this.isBanned(node)) {
        this.bannedNodes = [].concat(_toConsumableArray(this.bannedNodes), [node]);
        return true;
      }

      return false;
    }
  }, {
    key: "getNewNode",
    value: function getNewNode() {
      var _this = this;

      var nodes = this.nodes.filter(function (node) {
        return !_this.isBanned(node);
      });

      if (nodes.length === 0) {
        throw new Error('Cannot get new node: all nodes have been banned.');
      }

      var randomIndex = Math.floor(Math.random() * nodes.length);
      return nodes[randomIndex];
    }
  }, {
    key: "hasAvailableNodes",
    value: function hasAvailableNodes() {
      var _this2 = this;

      return this.nodes.some(function (node) {
        return !_this2.isBanned(node);
      });
    }
  }, {
    key: "initialize",
    value: function initialize(nodes) {
      var providedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!Array.isArray(nodes) || nodes.length <= 0) {
        throw new Error('APIClient requires nodes for initialization.');
      }

      if (typeof providedOptions !== 'object' || Array.isArray(providedOptions)) {
        throw new Error('APIClient takes an optional object as the second parameter.');
      }

      var options = Object.assign({}, defaultOptions, providedOptions);
      this.headers = Object.assign({}, commonHeaders, options.nethash ? {
        nethash: options.nethash
      } : {}, options.client ? getClientHeaders(options.client) : {});
      this.nodes = nodes;
      this.bannedNodes = _toConsumableArray(options.bannedNodes || []);
      this.currentNode = options.node || this.getNewNode();
      this.randomizeNodes = options.randomizeNodes !== false;
    }
  }, {
    key: "isBanned",
    value: function isBanned(node) {
      return this.bannedNodes.includes(node);
    }
  }]);

  return APIClient;
}();

exports.APIClient = APIClient;